var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"anyRating-main-title"},[(_vm.menuActive.totalCnName && _vm.menuActive.totalEnName)?_c('span',{staticClass:"anyRating-main-title-titleWord"},[_vm._v(_vm._s(_vm.$i18n.locale === "cn" ? _vm.menuActive.totalCnName : _vm.menuActive.totalEnName))]):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }